// WEB entrypoint

require('./bootstrap');
require('~styles/index.css');
